// resources/js/constants/pagesList.ts

interface PageChild {
  name: string;
  url: string;
  icon: string;
}

interface PageItem {
  name: string;
  url?: string;
  icon: string;
  protected?: boolean;
  children: PageChild[];
}

export const initialPagesList: PageItem[] = [
  {
    name: "Dashboard",
    url: "/",
    icon: "dashboard",
    protected: true,
    children: [],
  },
  {
    name: "Configuration",
    url: "/configuration",
    icon: "settings",
    protected: true,
    children: [],
  },
  {
    name: "Reports",
    url: "/reports",
    icon: "chartBar",
    protected: true,
    children: [
      { name: "Overall Reports", url: "/reports", icon: 'report' },
      { name: "Answered Call Recap", url: "/reports/answered-call", icon: 'phone' },
    ],
  },
  {
    name: "Billing",
    url: "/billing",
    icon: "card",
    protected: false,
    children: [],
  },
  {
    name: "Agency",
    url: "/agency",
    icon: "users",
    protected: true,
    children: [],
  },
  {
    name: "Integrations",
    url: "/integrations",
    icon: "integration",
    protected: true,
    children: [],
  },
];

export const adminPagesList: PageItem[] = [
  {
    name: "Dashboard",
    url: '/panel',
    icon: "dashboard",
    protected: false,
    children: [
      { name: "Live users", url: "/panel", icon: 'check' },
      { name: "Canceled Users", url: "/panel/canceled", icon: 'x' },
    ],
  },
  {
    name: "Agencies",
    url: "/panel/agencies",
    icon: "users",
    protected: false,
    children: [],
  },
  {
    name: "Plans",
    url: "/panel/plans",
    icon: "card",
    protected: false,
    children: [],
  },
  {
    name: "System Alerts",
    url: "/panel/alerts",
    icon: "bell",
    protected: false,
    children: [],
  },
];